export default class topManager {
    constructor(effect) {

        this.policy = document.getElementById('p-top-policy__list');
        this.policyHeight = this.policy.offsetHeight;
        this.policyOffset = this.policy.getBoundingClientRect().top;
        this.screenHeight = window.outerHeight;
        this.policyPosition = this.policyOffset - this.screenHeight;

        this.effect = effect;

    }
    init(){

        let _this = this;

        TweenMax.set(['#p-top-policy-svg01','#p-top-policy-svg02','#p-top-policy-svg03'], {
            opacity:0,
            scale:0.2,
            transformOrigin:"50% 50%"
        });

        let accessToken = '8204200120.974e847.0490d039c359406d953449330f360785';
        let username = 'nagoyaestate'; // ユーザーID
        $.ajax({
            url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+accessToken,
            dataType: 'jsonp',
            success: function(data) {
                for (let i = 0; i < data['data'].length; i++) {
                    let imagePath = data['data'][i]['images']['standard_resolution']['url'];
                    let imageLink = data['data'][i]['link'];
                    let imageTag = '<span class="swiper-slide"><a href="'+imageLink+'" target="_blank" style="background-image: url('+imagePath+')"></a></span>';
                    $('.swiper-wrapper').append(imageTag);
                };
            }
        });

    }

    render(){

    }
    resize(_w,_h,_display){

        let _this = this;

    }

    modal(type){

    }

}